
import { RevDivider } from '@ds/components/Divider'
import { RevIllustration } from '@ds/components/Illustration'
import { RevLink } from '@ds/components/Link'
import { IconUnlock } from '@ds/icons/IconUnlock'

import FormattedMessage from '@i18n/components/FormattedMessage'

import translations from './Carriers.translations'

export default {
  components: {
    FormattedMessage,
    IconUnlock,
    RevDivider,
    RevLink,
    RevIllustration,
  },

  props: {
    carriers: {
      type: Array,
      required: true,
    },
  },

  computed: {
    translations: () => translations,

    blogLink() {
      return {
        type: 'external',
        href: 'https://help.backmarket.com/hc/en-us/articles/360012437860',
      }
    },

    isSimLocked() {
      return this.carriers.some((carrier) => carrier.isSimLocked)
    },
  },
}
